import React from "react";
import { motion } from "framer-motion";
import { PLAYERS } from "../lib/quattro";

// Visual representation of a card (face up). Color matches its owner.
export default function CardView({ card, small = false, faded = false, glow = false }) {
  if (!card) return null;
  const p = PLAYERS[card.owner];
  const bg = `linear-gradient(155deg, ${p.color} 0%, ${shade(p.color, -22)} 100%)`;
  const isYellow = card.owner === 0;
  const text = isYellow ? "#0B0C10" : "#0B0C10";

  if (card.special) {
    return (
      <div
        className="card-face"
        style={{
          background: `linear-gradient(155deg, ${p.color}, #111)`,
          color: "#fff",
          boxShadow: glow ? `0 0 18px ${p.glow}` : undefined,
          border: `1px solid ${p.color}`,
        }}
        data-testid={`card-special-${card.special}`}
      >
        <div style={{ fontSize: small ? 9 : 10, letterSpacing: ".15em", opacity: .9 }}>
          {labelOfSpecial(card.special)}
        </div>
        <div style={{ fontSize: small ? 18 : 28, textAlign: "center", lineHeight: 1, fontWeight: 900 }}>
          {iconOfSpecial(card.special)}
        </div>
        <div style={{ fontSize: small ? 9 : 10, textAlign: "right", letterSpacing: ".15em", opacity: .8 }}>
          {p.suit}
        </div>
      </div>
    );
  }

  return (
    <div
      className="card-face"
      style={{
        background: bg,
        color: text,
        opacity: faded ? 0.5 : 1,
        boxShadow: glow ? `0 0 18px ${p.glow}` : undefined,
        border: `1px solid ${shade(p.color, -30)}`,
      }}
      data-testid={`card-${card.id}`}
    >
      <div className="card-power">{card.power}</div>
      <div className="card-suit">{p.suit}</div>
    </div>
  );
}

function shade(hex, percent) {
  const c = hex.replace("#", "");
  const num = parseInt(c, 16);
  let r = (num >> 16) + Math.floor(255 * percent / 100);
  let g = ((num >> 8) & 0xff) + Math.floor(255 * percent / 100);
  let b = (num & 0xff) + Math.floor(255 * percent / 100);
  r = Math.max(0, Math.min(255, r));
  g = Math.max(0, Math.min(255, g));
  b = Math.max(0, Math.min(255, b));
  return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
}

function iconOfSpecial(t) {
  if (t === "power_up") return "▲";
  if (t === "power_down") return "▼";
  if (t === "blocker") return "✦";
  if (t === "color_switcher") return "↔";
  return "★";
}
function labelOfSpecial(t) {
  if (t === "power_up") return "POWER UP";
  if (t === "power_down") return "POWER DOWN";
  if (t === "blocker") return "BLOCKER";
  if (t === "color_switcher") return "SWITCH";
  return "SPECIAL";
}

export const MotionCard = motion(CardView);
